import moment from 'moment';

const getBirthdayMonthDay = (dateOfBirth) => {
  if (typeof dateOfBirth !== 'string') {
    return null;
  }

  const isoDateMatch = dateOfBirth.match(/^(\d{4})-(\d{2})-(\d{2})/);

  if (!isoDateMatch) {
    return null;
  }

  return `${isoDateMatch[2]}-${isoDateMatch[3]}`;
};

export const isBirthdayToday = (dateOfBirth, currentDate = moment()) => {
  const birthdayMonthDay = getBirthdayMonthDay(dateOfBirth);

  if (!birthdayMonthDay) {
    return false;
  }

  return birthdayMonthDay === currentDate.format('MM-DD');
};

export const getBirthdayDisplayKey = (userId, currentDate = moment()) =>
  `birthdayDisplayed-${userId || 'anonymous'}-${currentDate.format('YYYY-MM-DD')}`;
